// src/components/Town/utils/summaryOfRevenuesAndExpendituresUtils.js

// Revenue side categories -> display labels
export const REVENUE_CATEGORY_CONFIG = [
  { key: "taxes", label: "Taxes" },
  { key: "licensesAndPermits", label: "Licenses & Permits" },
  { key: "intergovernmental", label: "Intergovernmental" },
  { key: "chargesForServices", label: "Charges for Services" },
  { key: "otherRevenues", label: "Other Revenues" },
  { key: "transfersIn", label: "Use of Fund Balance" },
];

// Town-side categories -> section names in Expenditures
export const TOWN_CATEGORY_LABELS = [
  "General Government",
  "Community Development",
  "Administrative Services",
  "Public Safety",
  "Physical Services",
  "Sanitation",
  "Human Services",
  "Leisure & Culture",
];

/**
 * Adds `increase` and `percentIncrease` fields to a summary row
 * based on y1_adopted (previous) and y0_adopted (current).
 */
export function computeIncreaseFields(row) {
  const prev = row.y1_adopted;
  const curr = row.y0_adopted;

  if (typeof prev === "number" && typeof curr === "number") {
    row.increase = curr - prev;
    row.percentIncrease = prev !== 0 ? ((curr - prev) / prev) * 100 : null;
  } else {
    row.increase = null;
    row.percentIncrease = null;
  }
  return row;
}

/**
 * Sum all rows across a list of sections into a single aggregate row.
 * sections: [{ name, rows: [...] }]
 */
export function aggregateFromSections(sections, columns, label) {
  const row = { label };
  const yearCols = columns.filter(
    (c) => !["label", "increase", "percentIncrease"].includes(c.key)
  );

  yearCols.forEach((col) => {
    let sum = 0;
    let hasVal = false;

    for (const section of sections || []) {
      for (const r of section.rows || []) {
        const v = r[col.key];
        if (typeof v === "number") {
          sum += v;
          hasVal = true;
        }
      }
    }

    if (hasVal) row[col.key] = sum;
  });

  return computeIncreaseFields(row);
}

/**
 * Sum all rows in a single section into a one-line aggregate row.
 */
export function aggregateFromSingleSection(section, columns, labelOverride) {
  if (!section) return null;
  return aggregateFromSections([section], columns, labelOverride || section.name);
}

/**
 * True if row has any non-zero numeric value in year columns.
 */
export function rowHasAnyNumeric(row, columns) {
  return columns.some((col) => {
    if (["label", "increase", "percentIncrease"].includes(col.key)) return false;
    const v = row[col.key];
    return typeof v === "number" && v !== 0;
  });
}
